import React from 'react';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';
import { t } from 'ttag';

import Button from '../ui/button/button';
import Icon from '../ui/icon/icon';

import SvgFir from './images/fir.svg';

import css from './errorDetails.css';

const ErrorDetails = ({ linkLabel, linkTo, text, title, useNativeLink }) => {
    const buttonNode = (
        <Button size="small" theme="blue" typeContour>
            {linkLabel}
        </Button>
    );
    return (
        <div className={css.root}>
            <div className={css.cell}>
                <div className={css.icon}>
                    <Icon glyph={SvgFir} />
                </div>
            </div>
            <div className={css.cell}>
                <div className={css.title}>{title}</div>
                <div className={css.text}>{text}</div>
                {useNativeLink ? (
                    <a href={linkTo}>{buttonNode}</a>
                ) : (
                    <Link to={linkTo}>{buttonNode}</Link>
                )}
            </div>
        </div>
    );
};

ErrorDetails.defaultProps = {
    linkLabel: t`Перейти на головну сторінку`,
    linkTo: '/',
    text: t`Зараз ми все полагодимо.`,
    title: t`Йой! Щось пішло не так.`,
    useNativeLink: true,
};

ErrorDetails.propTypes = {
    linkLabel: PropTypes.string,
    linkTo: PropTypes.string,
    text: PropTypes.node,
    title: PropTypes.node,
    useNativeLink: PropTypes.bool,
};

export default ErrorDetails;
